import { c as _c } from "react/compiler-runtime";
import type { IconProps } from '../types';
import { getIconColor } from '../utils/get-icon-color';
const IcoIdFront40 = t0 => {
  const $ = _c(9);
  const {
    "aria-label": ariaLabel,
    className,
    color
  } = t0;
  let t1;
  if ($[0] !== color) {
    t1 = getIconColor(color);
    $[0] = color;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const iconColor = t1;
  let t2;
  if ($[2] !== iconColor) {
    t2 = <g><circle cx={11.667} cy={11.667} fill={iconColor} r={1.667} /><circle cx={16.667} cy={11.667} fill={iconColor} r={1.667} /><path d="M10 15.8334C10 15.8334 11.0417 17.7727 14.1667 17.7727C17.2917 17.7727 18.3333 15.8334 18.3333 15.8334" stroke={iconColor} strokeWidth={2.5} strokeLinecap="round" /><rect x={24.286} y={24.286} width={5.714} height={2.5} rx={1.25} fill={iconColor} /><rect x={20.477} y={28.095} width={9.524} height={2.5} rx={1.25} fill={iconColor} /><rect x={5} y={5} width={30} height={30} rx={3.333} stroke={iconColor} strokeWidth={3.333} /></g>;
    $[2] = iconColor;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <defs />;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== ariaLabel || $[6] !== className || $[7] !== t2) {
    t4 = <svg width={40} height={40} viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg" aria-label={ariaLabel} className={className} role="img" data-colored={false}>{t2}{t3}</svg>;
    $[5] = ariaLabel;
    $[6] = className;
    $[7] = t2;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  return t4;
};
export default IcoIdFront40;